type Strings = Partial<Record<string, string>>;

export function combineStrings(strings: Strings, defaultStrings: Strings): Strings {
  const combinedStrings: Strings = {};
  Object.keys(defaultStrings).forEach((property) => {
    combinedStrings[property] = strings?.[property] ?? defaultStrings[property];
  });
  return combinedStrings;
}
